import { supabase } from './supabaseClient';

/**
 * Submit a contact form message
 * Requires user to be authenticated
 */
export const submitContactForm = async (formData) => {
  try {
    // Check if user is authenticated
    const { data: { user }, error: authError } = await supabase.auth.getUser();
    
    if (authError || !user) {
      return { 
        data: null, 
        error: { 
          message: 'You must be logged in to submit the contact form. Please sign in and try again.' 
        } 
      };
    }

    const { data, error } = await supabase
      .from('contact_submissions')
      .insert([
        {
          user_id: user.id,
          name: formData.name,
          email: formData.email,
          company: formData.company || null,
          subject: formData.subject || null,
          message: formData.message,
          contact_purpose: formData.subject || 'general-inquiry',
          created_at: new Date().toISOString(),
        },
      ])
      .select()
      .single();

    if (error) {
      // If table doesn't exist, log error but don't fail
      if (error.code === '42P01' || error.message.includes('does not exist')) {
        console.warn('Contact submissions table does not exist. Please create it in Supabase.');
        // Return success anyway for development
        return { data: { id: 'dev-' + Date.now() }, error: null };
      }
      throw error;
    }

    return { data, error: null };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    return { data: null, error };
  }
};

